import { render, staticRenderFns } from "./productUpdate.vue?vue&type=template&id=aeb10734&scoped=true&"
import script from "./productUpdate.vue?vue&type=script&lang=js&"
export * from "./productUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb10734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeb10734')) {
      api.createRecord('aeb10734', component.options)
    } else {
      api.reload('aeb10734', component.options)
    }
    module.hot.accept("./productUpdate.vue?vue&type=template&id=aeb10734&scoped=true&", function () {
      api.rerender('aeb10734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/order/orderManage/productUpdate.vue"
export default component.exports